import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { formatCurrency, getAccountHolderName } from '../../generalFunctions';
import Header from './common/Header';
import Signature from './common/Signature';
import { PDF_ALL_MARGIN, PDF_LEFT_MARGIN, PDF_RIGHT_MARGIN } from '../../constants';

const styles = StyleSheet.create({
    rowView: {
        flexDirection: 'row', borderTop: '1px solid #000', padding: 3, marginRight: 20, textAlign: "center"
    }
});

const DebitNoteBillwisePdf = (props) => {
    let billData = props.data.billData;

    billData.forEach((bill,index)=> {
        bill.Sr = index +1;
        bill.billAmount = formatCurrency(bill.billAmount);
        bill.debitAmount = formatCurrency(bill.debitAmount);
    })

    billData.push({
        billAmount: "Total Amount:",
        debitAmount: formatCurrency(props.data.amount)
    });


    const tableData = {
        columnName: ["Sr", "Bill Date", "Bill No", "Bill Amount", "Debit Amount", "Particulars"],
        column: ["Sr", "billDate", "billNumber", "billAmount", "debitAmount", "particulars"],
        width: [10, 15, 15, 15, 15, 30],
        data: billData
    }

    return (
        <Page style={{ paddingLeft: PDF_LEFT_MARGIN, margin: PDF_ALL_MARGIN, paddingRight: PDF_RIGHT_MARGIN }} size="A4">
            <View style={{ border: 2, padding: 5 }}>
            <Header title={"D  E  B  I  T     N  O  T  E"} id={props.data.id} date={props.data.debitNoteDate} hideGst={true}/>

            <View style={{ flexDirection: "row", padding: 10, marginBottom: 5 }}>
                <Text style={{
                    fontSize: 11,
                    flexDirection: "column",
                    flexGrow: 0.05
                }}>NAME:</Text>
                <Text style={{
                    fontSize: 11,
                    flexDirection: "column",
                    marginRight: 20,
                    flexGrow: 1,
                }}>{props.data.creditor}</Text>
            </View>

            <Fragment>
                <View style={styles.rowView}>
                    {tableData["columnName"].map((c, index) => <Text style={{
                        width: `${tableData["width"][index]}%`, fontSize: 9
                    }}>{c.toUpperCase()}</Text>)}
                </View>
                {tableData["data"].map((rowData) => <>
                    <View style={styles.rowView}>
                        {tableData["column"].map((c, index) =>
                            <Text style={{ width: `${tableData["width"][index]}%`, fontSize: 10 }}>{rowData[c]}</Text>
                        )}
                    </View>
                </>)}
            </Fragment>
            <View style={{ flexDirection: "row", marginBottom: 20}}></View>
            <Signature />
            </View>
        </Page>
    );
}

export default DebitNoteBillwisePdf;